import { useEffect } from "react";
import { useInfiniteQuery } from "@tanstack/react-query";
import searchOrganizationProfiles from "../axios/searchOrganizationProfiles";

/**
 * @description This hook is similar to useQuerySearchOrganizationProfiles but it automatically fetches all pages.
 */
const useQueryAllSearchOrganizationProfiles = (searchTerm: string) => {
  const response = useInfiniteQuery(
    ["search_organisasi_internasional", searchTerm],
    ({ pageParam = 1 }) => {
      return searchOrganizationProfiles({
        search: searchTerm,
        page: pageParam,
      });
    },
    {
      enabled: Boolean(searchTerm.trim()),
      getNextPageParam: (lastPage, allPages) => {
        const organizationProfilesList = allPages.flatMap(
          (page) => page.organisasi_internasional.data,
        );
        if (
          organizationProfilesList.length <
          lastPage.organisasi_internasional.total
        ) {
          return lastPage.organisasi_internasional.current_page + 1;
        }
        return undefined;
      },
    },
  );

  const { hasNextPage, isFetchingNextPage, fetchNextPage } = response;

  useEffect(() => {
    if (hasNextPage && !isFetchingNextPage) {
      fetchNextPage();
    }
  }, [fetchNextPage, hasNextPage, isFetchingNextPage]);

  return response;
};

export default useQueryAllSearchOrganizationProfiles;
